import { render, staticRenderFns } from "./MainCart.vue?vue&type=template&id=1424a5cf&scoped=true&"
import script from "./MainCart.vue?vue&type=script&lang=ts&"
export * from "./MainCart.vue?vue&type=script&lang=ts&"
import style0 from "./MainCart.vue?vue&type=style&index=0&id=1424a5cf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1424a5cf",
  null
  
)

export default component.exports